// extracted by mini-css-extract-plugin
export default {"container":"eCategory_container__iRXcZ","drop":"eCategory_drop__jmIQ6"};